import React, { useState } from "react";
import Swal from 'sweetalert2';
import '@sweetalert2/theme-dark/dark.css';
export default function CTAOne() {
  const [email, setEmail] = useState('');

  const toastMsg = (iconType, msg) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
    Toast.fire({
      icon: iconType,
      title: msg
    });
  };

  const [loading, setLoading] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate email
    if (!email) {
      toastMsg("error", 'Email is required');
      return;
    }
    if (!emailRegex.test(email)) {
      toastMsg("error", 'Please enter a valid email address');
      return;
    }

    if (!loading) {
      setLoading(true);
      try {
        const response = await fetch("https://script.google.com/macros/s/AKfycbytNUfgHWcaM6Ed-JcvdD73LplaU9Uj4oZwNJDCgL-S1de1_yTiDgPzvprYJCqUNTE9aA/exec", {
          method: "POST",
          body: JSON.stringify({email: email}),
          headers: {
            "Content-Type": "text/plain"
          }
        });

        const result = await response.json();
        //console.log("Response from Google Script:", result);

        if (result.result === "Success") {
          toastMsg("success", "Email submitted");
        } else {
          toastMsg("error", "Something went wrong");
        }

      } catch (error) {
        console.error("Fetch error:", error);
        alert("Fetch failed. Check console for details.");
      }
      setLoading(false);
      setEmail('');
    }


  }
  return (
    <section className="cta-one">
      <div className="container">
        <div className="cta-one__inner">
          <h3 className="cta-one__title">
            Get Latest Updates Subscribe <br /> to Our Newsletter
          </h3>
          <form
            onSubmit={handleSubmit}
            className="cta-one__form mc-form"
            noValidate
          >
            <div className="cta-one__form-input-box">
              <input
                type="email"
                placeholder="Enter your email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                required
              />

              <button type="submit" className="cta-one__btn">
                {loading ? (
                  <span className="fas fa-circle-notch fa-spin"></span>
                ) : (
                  <span className="icon-paper-plan"></span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
